import { hasPermission, fetchAllPermissions } from "@/composables/usePermissions.js"
import { cachedAuthorizationUser } from "@/composables/useAccount.js"

const currentUser = cachedAuthorizationUser()

const nonPartnerGuard = async (to, from, next) => {
  const { role } = await currentUser.fetchAuthorizationUser()
  if (["partner", "direct_reseller", "distributor", "involved_reseller"].includes(role)) {
    return next()
  }
  next("/no-partner")
}

const permissionGuard = permission => async (to, _, next) => {
  const permissions = await fetchAllPermissions()
  if (!hasPermission(permissions, permission, to.params.id)) {
    return next("/no-permission")
  }
  next()
}

const roleGuard = (roles, path) => async (_, __, next) => {
  const { role } = await currentUser.fetchAuthorizationUser()
  if (roles.includes(role)) {
    next()
  }
  else if (path) {
    next(path)
  }
  else {
    next("/no-permission")
  }
}

export {
  nonPartnerGuard,
  permissionGuard,
  roleGuard,
}
